module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/tcby-text-914ea3be0d9f754264d5d4b08091f3af.svg";